import React from 'react'
import PropTypes from 'prop-types'

import Grid from '@material-ui/core/Grid'

import Insured from '../fragments/Insured'
import Requester from '../fragments/Requester'
import FileUpload from '../fragments/FileUpload'
import PolicyHolder from '../fragments/PolicyHolder'
import { useEndorsement } from '../../../shared/contexts/EndorsementContext'

import {
  STEP_TYPE_FIRST_TEMPLATE,
  STEP_TYPE_FIRST_OTHER_BROKERAGE_TEMPLATE,
  ENDORSEMENT_TYPE_CANCELLATION,
} from '../../../constants/EndorsementConstants'

const FirstTemplateEndorsement = (props) => {
  const {
    refs,
    quote,
    checked,
    handleStep,
    handleNext,
    handlePrevious,
    handleRegister,
    handleNextExternal,
    otherBrokerageDocument,
    isCancellation,
  } = props

  const { endorsementTypeStateSelected } = useEndorsement()
  const isCancellationLocal = isCancellation ?? (
    endorsementTypeStateSelected?.id === ENDORSEMENT_TYPE_CANCELLATION
  )

  const verifyOtherBrokerage = otherBrokerageDocument
    ? STEP_TYPE_FIRST_OTHER_BROKERAGE_TEMPLATE : STEP_TYPE_FIRST_TEMPLATE

  const stepNumbers = isCancellationLocal ? {
    REQUESTER: 1,
    FILE_UPLOAD: 2,
  } : {

    REQUESTER: verifyOtherBrokerage.REQUESTER,
    FILE_UPLOAD: verifyOtherBrokerage.FILE_UPLOAD,
  }

  return (
    <>
      {otherBrokerageDocument && (
        <Grid item xs={12}>
          <PolicyHolder
            quote={quote}
            handleNext={handleNext}
            handlePrevious={handlePrevious}
            ref={refs[STEP_TYPE_FIRST_OTHER_BROKERAGE_TEMPLATE.POLICY_HOLDER]}
            checked={checked(STEP_TYPE_FIRST_OTHER_BROKERAGE_TEMPLATE.POLICY_HOLDER) ?? false}
            handleStep={handleRegister}
          />
        </Grid>
      )}
      {!isCancellation && (
      <Grid item xs={12}>
        <Insured
          quote={quote}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          ref={refs[verifyOtherBrokerage.INSURED]}
          checked={checked(verifyOtherBrokerage.INSURED) ?? false}
          handleStep={() => handleStep(verifyOtherBrokerage.INSURED)}
        />
      </Grid>
      )}
      <Grid item xs={12}>
        <Requester
          quote={quote}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          ref={refs[stepNumbers.REQUESTER]}
          checked={checked(stepNumbers.REQUESTER) ?? false}
          handleStep={() => handleStep(stepNumbers.REQUESTER)}
        />
      </Grid>
      <Grid item xs={12}>
        <FileUpload
          quote={quote}
          handleNext={handleNext}
          handlePrevious={handlePrevious}
          ref={refs[stepNumbers.FILE_UPLOAD]}
          checked={checked(stepNumbers.FILE_UPLOAD) ?? false}
          handleStep={handleRegister}
          handleNextExternal={handleNextExternal}
        />
      </Grid>
    </>
  )
}

FirstTemplateEndorsement.propTypes = {
  quote: PropTypes.any,
  refs: PropTypes.any.isRequired,
  checked: PropTypes.any.isRequired,
  handleStep: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handlePrevious: PropTypes.func.isRequired,
  handleRegister: PropTypes.func.isRequired,
  handleNextExternal: PropTypes.func.isRequired,
  otherBrokerageDocument: PropTypes.bool.isRequired,
  isCancellation: PropTypes.bool,
}

FirstTemplateEndorsement.defaultProps = {
  quote: undefined,
  isCancellation: false,
}

export default FirstTemplateEndorsement
